/* eslint-disable no-unused-vars */
import React, { ElementType } from 'react';
import { Box, Flex, Icon, Menu, MenuButton, MenuItem, MenuList, Text } from '@chakra-ui/react';
import { CaretDown, CaretUp, Check } from 'phosphor-react';

export interface FilterSelectOption {
  value: string;
  label: string;
}

interface FilterSelectProps {
  icon?: ElementType;
  options: FilterSelectOption[];
  value: string;
  onChange: (value: string) => void;
  ariaLabel: string;
}

export const FilterSelect = ({ icon, options, value, onChange, ariaLabel }: FilterSelectProps) => {
  const selected = options.find((option) => option.value === value) ?? options[0];
  return (
    <Menu placement="bottom-start" autoSelect={false}>
      <MenuButton
        as={Flex}
        role="button"
        tabIndex={0}
        aria-label={ariaLabel}
        h="34px"
        px="10px"
        align="center"
        gap="8px"
        bg="surface.base"
        border="1px solid"
        borderColor="line.input"
        borderRadius="lg"
        boxShadow="control"
        cursor="pointer"
        fontSize="13px"
        color="content.strong"
        _hover={{ borderColor: '#DCDCDC' }}
        _focusVisible={{ borderColor: 'line.ring', boxShadow: 'outline', outline: 'none' }}
        _expanded={{ bg: 'surface.selected' }}
      >
        <Flex align="center" gap="8px">
          {icon && <Icon as={icon} w="14px" h="14px" color="content.subtle" flexShrink={0} />}
          <Text as="span" whiteSpace="nowrap">
            {selected?.label}
          </Text>
          <Box
            as="span"
            display="flex"
            flexDirection="column"
            alignItems="center"
            color="content.strong"
            opacity={0.8}
            ml="2px"
            sx={{ '& > svg + svg': { mt: '-8px' } }}
          >
            <CaretUp size={14} />
            <CaretDown size={14} />
          </Box>
        </Flex>
      </MenuButton>
      <MenuList minW="200px">
        {options.map((option) => (
          <MenuItem
            key={option.value}
            onClick={() => onChange(option.value)}
            display="flex"
            justifyContent="space-between"
            gap="12px"
          >
            {option.label}
            {option.value === value && <Check size={14} />}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};
